import { render, staticRenderFns } from "./singapore10Years.vue?vue&type=template&id=a823d1d8&scoped=true&"
import script from "./singapore10Years.vue?vue&type=script&lang=js&"
export * from "./singapore10Years.vue?vue&type=script&lang=js&"
import style0 from "./singapore10Years.vue?vue&type=style&index=0&id=a823d1d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a823d1d8",
  null
  
)

export default component.exports